import { message } from "antd";
import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { useGetOrganizationById } from "../../../api/v1";

import { PaymentTypeBase, PaymentTypeRecord } from "./types";

type OrganizationWithPaymentTypes = {
  masterPaymentTypes?: PaymentTypeBase[];
};

export function usePaymentsTypes() {
  const [searchParams] = useSearchParams();
  const orgId = searchParams.get("orgId");

  const { data, isErrorOrganization, refetchOrganization } = useGetOrganizationById<OrganizationWithPaymentTypes>({
    orgId,
    params: { filterkeys: "masterPaymentTypes" },
  });

  useEffect(() => {
    if (isErrorOrganization) {
      message.error("Something went wrong while fetching payment types");
      return;
    }

    if (data && !data.success) {
      message.error(data.message ?? "Failed to fetch payment types");
    }
  }, [data, isErrorOrganization]);

  const paymentTypes = useMemo<PaymentTypeRecord[]>(() => {
    if (!data?.success) return [];

    const masterPaymentTypes = data.result?.masterPaymentTypes;
    if (!masterPaymentTypes || !Array.isArray(masterPaymentTypes)) return [];

    return masterPaymentTypes.map((payment) => ({
      uid: crypto.randomUUID(),
      ...payment,
      propertyLabels: payment?.propertyLabels,
    }));
  }, [data]);

  return {
    paymentTypes,
    refetchPaymentTypes: async () => {
      await refetchOrganization();
    },
  };
}
